import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=4b1f6e30&scoped=true&"
import script from "./Pagination.vue?vue&type=script&lang=js&"
export * from "./Pagination.vue?vue&type=script&lang=js&"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=4b1f6e30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1f6e30",
  null
  
)

component.options.__file = "Pagination.vue"
export default component.exports